import { api, API } from "@/lib/api";

// Runs the full job-based download: start -> poll progress -> fetch file -> save.
// onProgress receives { status, percent, speed, eta, title }.
export async function runDownload({ url, quality, watermarkText, watermarkPosition, watermarkLogo, watermarkOpacity, watermarkSize, watermarkColor, onProgress }) {
  const token = localStorage.getItem("vg_token");
  let jobId;
  try {
    const { data } = await api.post("/video/download/start", {
      url,
      quality,
      watermark_text: watermarkText || null,
      watermark_position: watermarkPosition || "bottom-right",
      watermark_logo: watermarkLogo || null,
      watermark_opacity: watermarkOpacity != null ? watermarkOpacity : 0.9,
      watermark_size: watermarkSize || "medium",
      watermark_color: watermarkColor || "white",
    });
    jobId = data.job_id;
  } catch (e) {
    if (e.response?.status === 402) {
      const err = new Error(e.response.data?.detail || "Daily free limit reached.");
      err.limit = true;
      throw err;
    }
    throw e;
  }

  // Poll server-side progress
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { data: p } = await api.get(`/video/download/progress/${jobId}`);
    onProgress && onProgress(p);
    if (p.status === "ready") break;
    if (p.status === "error") throw new Error(p.error || "Download failed");
    await new Promise((r) => setTimeout(r, 700));
  }

  onProgress && onProgress({ status: "saving", percent: 100 });

  const res = await fetch(`${API}/video/download/file/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Could not fetch file");

  const blob = await res.blob();
  const dispo = res.headers.get("Content-Disposition") || "";
  const match = dispo.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const filename = match
    ? decodeURIComponent(match[1])
    : quality === "audio"
    ? "audio.mp3"
    : "video.mp4";

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);
}
